<template>
  <p v-if="commodity">
    <template v-if="commodity === 'cargo.variousCommodities'">{{ $t(row.cargo.commodity) }}<br /></template>
    <template v-else>{{ commodity }}<br /></template>
  </p>

  <p class="color-neutral-subtle">
    <template v-if="packageQuantity && packageQuantityUnit"
      >{{ $t("common.in") }} {{ packageQuantity }} x {{ packageQuantityUnit }}
    </template>
    <template v-else-if="packageQuantity">
      {{ packageQuantity }}
    </template>

    <template v-else-if="packageQuantityUnit">
      <template v-if="packageQuantityUnit === 'cargo.variousCommodities'">{{ $t(packageQuantityUnit) }}</template>
      <template v-else>{{ packageQuantityUnit }}</template>
    </template>
    <template v-else>-</template>
  </p>
</template>

<script>
export default {
  props: {
    commodity: {
      type: String,
      required: false,
      default: null
    },
    packageQuantity: {
      type: [Number, String],
      required: true
    },
    packageQuantityUnit: {
      type: String,
      required: true
    }
  }
};
</script>
